
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'test',
	'visualizationSlideoutTitle': 'Visualiseringer',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Angiv et tal',
	'maxValuePlaceholder': 'Angiv et tal',
	'customRangeErrorMessage': 'Værdien skal være et tal',
	'propFillColor': 'Udfyldningsfarve',
	'propBorderColor': 'Kantfarve',
	'propColorPalette': 'Aktuel farvepalet',
	'propColorPaletteChangeLabel': 'Skift farvepalet',
	'propNewColorPaletteLabel': 'Opret en tilpasset farvepalet',
	'propNewHeatPaletteLabel': 'Opret en tilpasset varmepalet',
	'propDonutRadius': 'Kransradius',
	'showTitleLabel': 'Vis titel',
	'titleTypeLabel': 'Titeltype',
	'smartTitleLabel': 'Smarttitel',
	'customTitleLabel': 'Tilpasset titel',
	'noTitleLabel': 'Ingen titel',
	'propHeatScalePalette': 'Aktuel varmepalet',
	'propHeatPaletteChangeLabel': 'Skift varmepalet',
	'propMaintainAxisScales': 'Bevar akseskala',
	'propLineAndSymbolColor': 'Linje- og symbolfarve',
	'propLineAndSymbolPalette': 'Farvepalet til linjer og symboler',
	'propElementColor': 'Elementfarve',
	'propColumnColor': 'Kolonnefarve',
	'propColumnPalette': 'Farvepalet til kolonne',
	'propColumnHeatPalette': 'Varmepalet til kolonner',
	'propBarColor': 'Søjlefarve',
	'propGoalColor': 'Målfarve',
	'propToColor': 'Til-farve',
	'propFromColor': 'Fra-farve',
	'propNumberValidationErrorMessageId': 'Angiv et tal',
	'fontSizeAuto': 'Automatisk',
	'propAutoBinCount': 'Antal grupper',
	'propAutoBinToggle': 'Auto-gruppering',
	'tabName_general': 'Generelt',
	'tabName_visDetails': 'Detaljer',
	'tabName_animation': 'Animering',
	'tabName_mediaDetails': 'Detaljer om medier',
	'tabName_webDetails': 'Detaljer om websider',
	'tabName_imageDetails': 'Billeddetaljer',
	'tabName_visualization': 'Visualisering',
	'tabName_text': 'Tekst',
	'sectionName_colorsAndThemes': 'Farve og temaer',
	'sectionName_appearance': 'Udseende',
	'sectionName_general': 'Generelt',
	'sectionName_colorPalette': 'Farve',
	'sectionName_axis': 'Akse',
	'sectionName_axis_label': 'Akse',
	'sectionName_legend': 'Beskrivelse',
	'sectionName_chart': 'Diagram',
	'sectionName_regionLayer': 'Regionslag',
	'sectionName_pointLayer': 'Punktlag',
	'sectionName_latLongLayer': 'Lag med breddegrad/længdegrad',
	'sectionName_pathLayer': 'Stilag',
	'propTransparencyDescription': 'Gør objektet mere eller mindre gennemsigtigt. Skriv en værdi mellem 0 og 100',
	'smart_annotation_unauthorized': 'Annotationer: Uautoriseret adgang',
	'smart_annotation_method': 'Annotationer: Metode er ikke tilladt',
	'smart_annotation_media': 'Annotationer: Medietype er ikke tilladt',
	'smart_annotation_input': 'Annotationer: Input ugyldigt',
	'smart_annotation_internal': 'Annotationer: Intern systemfejl',
	'smart_annotation_generic_error': 'Annotationer: Servicefejl',
	'smart_annotation_dialog_title': 'Indsigter',
	'smart_errors': 'Annotationsfejl:',
	'smart_warnings': 'Annotationsadvarsler:',
	'smart_annotation_insight_icon_title': 'Indsigter',
	'smart_annotations_toggle_on': 'Aktivér indsigter',
	'smart_annotations_toggle_off': 'Deaktivér indsigter',
	'smart_annotation_insight_unavailable': 'Indsigter er ikke tilgængelige i øjeblikket',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Indsigter er ikke tilgængelige, når der anvendes et filter af typen Top eller Bund %',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Prognose er ikke tilgængelige, når der anvendes et filter af typen Top eller Bund %',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Indsigter er ikke tilgængelige, når der anvendes et filter af typen Top eller Bund, og der kun er én tilgængelig kolonne i feltet',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Prognose er ikke tilgængelige, når der anvendes et filter af typen Top eller Bund, og der kun er én tilgængelig kolonne i feltet',
	'forecast_title': 'Prognose',
	'forecast_toggle_on': 'Aktivér prognoser',
	'forecast_toggle_off': 'Deaktivér prognoser',
	'statDetailsPerspectiveTitle': 'Analyse',
	'emptyStatDetailsPanel': 'Der er ingen yderligere analyse tilgængelig for den aktuelle visualisering.',
	'predict_errors': 'Analysefejl',
	'predict_warnings': 'Analyseadvarsler',
	'fpd_invalid_data_source': 'Denne datakilde har ikke et tilknyttet smarts-modul',
	'fpd_network_issue': 'Der er et problem med analyse i forhold til denne datakilde',
	'fpd_data_source_category': 'Smarts-modulet mangler',
	'fpd_response_errors': 'Fejl i anbefalet styreprogram',
	'fpd_response_warnings': 'Advarsler i anbefalet styreprogram',
	'catalyst_service_bad_request': 'Defekt anmodning',
	'catalyst_service_unkown_Id': 'Ukendt anmodnings-id',
	'catalyst_service_internal_server_error': 'Intern serverfejl',
	'catalyst_service_generic_error': 'Katalystservicefejl',
	'catalyst_service_error': 'Denne service er ikke tilgængelig i øjeblikket',
	'propLegendPosition': 'Beskrivelsesposition',
	'propLeft': 'Venstre',
	'propRight': 'Højre',
	'propTop': 'Top',
	'propBottom': 'Nederst',
	'propNone': 'Ingen',
	'propLegendDisplay': 'Vis beskrivelse',
	'targetThicknessPlaceHolder': '%{min} til %{max}',
	'targetThicknessErrorMsg': 'Angiv et helt tal mellem %{min} og %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Styreprogrammer (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'valgt)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Nulstil til standard',
	'possibelKeyDriver_AddNewDrivers': 'Tilføj flere styreprogrammer',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Søg for at tilføje flere styreprogrammer',
	'possibleKeyDrivers_MaxPossibleReached': 'Fravælg nogle styreprogrammer for at tilføje eller vælge andre',
	'possibleKeyDrivers_Recommended': 'Anbefalede',
	'visRecommendedTypes': 'Anbefalede visualiseringstyper',
	'visRecommender_smartsfailure': 'visualiseringsanbefalinger er ikke tilgængelige i øjeblikket',
	'visMore': 'Mere...',
	'visMoreTooltip': 'Flere visualiseringer',
	'visOtherTypes': 'Andre visualiseringstyper',
	'visChange': 'Skift visualisering',
	'automaticTypeCaption': 'Automatisk',
	'propVisType': 'Visualiseringstyper',
	'dlg_loading': 'Indlæser...',
	'snippetListChartCaption': 'Stykkeliste',
	'convoClusterChartCaption': 'Konversationsklynge',
	'areaChartCaption': 'Område',
	'barChartCaption': 'Søjle',
	'columnChartCaption': 'Kolonne',
	'stackedbarChartCaption': 'Stakket søjle',
	'stackedcolumnChartCaption': 'Stakket kolonne',
	'bubbleChartCaption': 'Boble',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Styreprogramanalyse',
	'scatterChartCaption': 'Punktdiagram',
	'lineChartCaption': 'Linje',
	'pointChartCaption': 'Punkt',
	'heatChartCaption': 'Varmekort',
	'bulletChartCaption': 'Punktopstilling',
	'waterfallChartCaption': 'Vandfald',
	'pieChartCaption': 'Lagkage',
	'mapChartCaption': 'Kort',
	'radialBarChartCaption': 'Radial',
	'compositeChartCaption': 'Linje og kolonne',
	'wordCloudChartCaption': 'Ordsky',
	'networkChartCaption': 'Netværk',
	'relationshipNetworkChartCaption': 'Relationsnetværk',
	'treemapChartCaption': 'Træstruktur',
	'packedBubbleChartCaption': 'Pakket boble',
	'hierarcicalPackedBubbleChartCaption': 'Hierarkiboble',
	'spiralChartCaption': 'Spiral',
	'decisionTreeChartCaption': 'Beslutningstræ',
	'legacyMapChartCaption': 'Ældre kort',
	'sunburstChartCaption': 'Sunburst',
	'visUsageComparison': 'Sammenligning',
	'visUsageRelationships': 'Relationer',
	'visUsageTrend': 'Tendens',
	'visUsagePartsToWhole': 'Dele til hele',
	'visUsageGeospatial': 'Geospatial',
	'visUsageAdvanced': 'Avancerede analyser',
	'visUsageTablesAndSummary': 'Tabeller og resumé',
	'visUsageSocialInsights': 'Social insights',
	'visUsageOther': 'Andet',
	'autoBinActionText': 'Auto-gruppér',
	'filterAutobinActionText': 'Filtrér områder (bins)',
	'memberCalculationActionText': 'Medlemsberegning',
	'toolbarActionCalculation': 'Beregning',
	'toolbarActionEditCalculation': 'Redigér beregning',
	'topBottomRankLabel': 'Prioritet (%{label})',
	'toolbarDeleteFilterActionText': 'Fjern filter',
	'toolbarActionTopKeyDrivers': 'Vis styreprogrammer',
	'toolbarActionCustomGroup': 'Tilpasset gruppe',
	'canNotCreateCustomGroup': 'Vi kan ikke oprette denne tilpassede gruppe.',
	'aria_label_datatable': 'Datatabel',
	'summaryCaption': 'Opsummering',
	'MeasuresCaption': 'Målinger',
	'MeasuresGroupCaption': 'Målingsgruppe (%{count})',
	'ValuesCaption': 'Værdier',
	'turnInsightsOn': 'Aktivér indsigter',
	'turnInsightsOff': 'Deaktivér indsigter',
	'decisionRules': 'Regler',
	'decisionTree': 'Trædiagram',
	'decisionSunburst': 'Træstruktur - sunburst',
	'switchToDecisionRules': 'Skift til beslutningsregler',
	'switchToDecisionTree': 'Skift til beslutningstræ',
	'data_group_less_then': 'mindre end %{rangeTo}',
	'data_group_to': '%{rangeFrom} til < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} og derover',
	'nullValueContent': '(ingen værdi)',
	'sum': 'Sum',
	'count': 'Antal',
	'countdistinct': 'Antal forskellige',
	'avg': 'Gennemsnit',
	'min': 'Minimum',
	'max': 'Maksimum',
	'automatic': 'Tilpasset',
	'variance': 'Varians',
	'stddev': 'Standardafvigelse',
	'median': 'Median',
	'calculated': 'Beregnet',
	'none': 'Ingen',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'unSupportedPromptType': 'Promptscenariet understøttes ikke i øjeblikket.',
	'preAggregateLabel': 'Anvend promptværdier fra datakilden',
	'postAggregateLabel': 'Anvend promptværdier i rapporten',
	'preAggregateText': 'Intervallet anvender værdierne i datakilden - ikke værdierne, der vises på dashboardet.',
	'defaultAggregation_count': 'Antal',
	'defaultAggregation_countdistinct': 'Antal forskellige',
	'defaultAggregation_max': 'Maksimum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Gennemsnit',
	'defaultAggregation_sum': 'Sum',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',
	'keydriver_average': 'Generelt gennemsnit',
	'keydriver_up_down': 'De fremhævede grupper med høje eller lave gennemsnit har større indvirkning på målet. Grupper med usædvanligt høje eller lave gennemsnit har den største indvirkning.',
	'keydriver_different': 'Fremhævede grupper har fordelinger, der afviger væsentligt fra den generelle fordeling. Disse grupper har større indvirkning på målet.',
	'topOperator': 'Top',
	'bottomOperator': 'Nederst',
	'topBottomFact': '%{operator} %{value}%{percent} efter %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Slet antal for øverste eller nederste',
	'deleteTopBottomPercent': 'Slet procent for øverste eller nederste',
	'topBottomTitle': 'Kun dette objekt',
	'deleteTopBottom': 'Slet antal for øverste eller nederste',
	'editTopBottom': 'Redigér antal for øverste eller nederste',
	'editTopBottomCount': 'Redigér antal for øverste eller nederste',
	'editTopBottomPercent': 'Redigér procent for øverste eller nederste',
	'ariaDeleteTopBottomCountLabel': 'Tryk på DELETE for at slette antal øverste eller nederste.',
	'ariaDeleteTopBottomPercentLabel': 'Tryk på DELETE for at slette øverste eller nederste procent',
	'ariaEditTopBottomCountLabel': 'Tryk på ENTER for at redigere antal øverste eller nederste.',
	'ariaEditTopBottomPercentLabel': 'Tryk på ENTER for at redigere øverste eller nederste procent.',
	'ariaDeleteDrillStateLabel': 'Tryk på ENTER for at redigere antal øverste eller nederste.',
	'drillUpStateTitle': 'Drill-up',
	'drillDownStateTitle': 'Drill-down',
	'ariaEditTopBottomLabel': 'Tryk på ENTER for at redigere antal øverste eller nederste.',
	'ariaDeleteTopBottomLabel': 'Tryk på DELETE for at slette antal øverste eller nederste.',
	'allKeyDriversLabel': 'Auto (alle styreprogrammer)',
	'filter_drag_and_drop_single_dock': 'Træk og placér data her for at filtrere',
	'filter_drag_and_drop_all_tabs': 'Træk og placér data her for at filtrere alle faner.',
	'filter_drag_and_drop_current_tab': 'Træk og placér data her for at filtrere denne fane.',
	'filter_empty_consume_mode': 'Ingen filtre er blevet anvendt.',
	'filterClearAllItems': 'Ryd alle filtre',
	'filterDeleteAllItems': 'Slet alle filtre',
	'filterDockChevronLeft': 'Blad gennem dataene',
	'filterDockChevronRight': 'Blad gennem dataene',
	'filterIconLabel_Single': 'Filtrerer',
	'filterIconLabel_Global': 'Alle skilleblade',
	'filterIconLabel_Tab': 'Dette skilleblad',
	'filterIconTooltip_Single': 'Filtrerer',
	'filterIconTooltip_Global': 'Filtre til alle skilleblade',
	'filterIconTooltip_Tab': 'Filtre til dette skilleblad',
	'filterDropZoneTooltip_Single': 'Filterplaceringszone',
	'filterDropZoneTooltip_Global': 'Filtrér placeringszone for alle skilleblade',
	'filterDropZoneTooltip_Tab': 'Filterplaceringszone for dette skilleblad',
	'filterOverflowMenu': 'Mere',
	'expand': 'Udvid',
	'collapse': 'Skjul',
	'filterDockItemNameAriaLabel': 'Tryk på Enter for at starte filterdialogen, og definér filtret.',
	'filterItemCanvasMove': 'Tilføj til lærred',
	'filterItemDelete': 'Slet filter',
	'filterInvertRange': 'alt undtagen: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Ikke efter %{from}',
	'filter_date_after': 'Efter %{from}',
	'filter_date_before_except': 'Ikke før %{to}',
	'filter_date_before': 'Før %{to}',
	'filter_date_between_except': 'Ikke mellem %{from} og %{to}',
	'filter_date_between': 'Mellem %{from} og %{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Alle',
	'filterExcept': 'undtagen %{values}',
	'filterDockToolbarButtonLabel': 'Fastgør filter',
	'navigateTitle': 'Navigér til',
	'current_nav_group': 'Aktuel navigationsgruppe er %{navigation_group_name}',
	'next': 'Næste',
	'previous': 'Forrige',
	'multiselectMsg': '%{count} valgt',
	'errMsgFilterItemMissingTitle': 'Filterværdien %{itemName} kan ikke indlæses, fordi disse værdier ikke er tilgængelige med dette datasæt',
	'errMsgFilterItemGenericTitle': 'Filterværdier kan ikke indlæses',
	'textFilterItemsNotFound': 'Der er ingen tilgængelige elementer.',
	'nullValueLabel': '(tom)',
	'filterConditionLabel': 'Filterbetingelse',
	'filter_includesAll': 'Inkluderer alle',
	'filter_allMembersOfSet': 'Alle medlemmer af sættet',
	'modelFilter': 'Filtrér',
	'filtersTitle': 'Egenskaber for filtrering',
	'search': 'Søg',
	'clearTextFilterValue': 'Ryd',
	'invertFilterSelection': 'Omvendt',
	'modellingLoading': 'Indlæser...',
	'searchAll': 'Søg efter alle kolonner',
	'toolbarActionPossibleKeyDrivers': 'Redigér omfang',
	'toolbarActionPossibleKeyDriversSubTitle': 'Træk elementer fra venstre, som indsættes i styreprogramsanalysediagrammet.',
	'toolbarActionSort': 'Sortér',
	'toolbarActionSortAscending': 'Sortér stigende',
	'toolbarActionSortDescending': 'Sortér faldende',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionSortCustom': 'Tilpasset',
	'toolbarActionFormat': 'Format',
	'toolbarActionFormatAbbreviation': 'Forkort',
	'toolbarActionFormatNone': 'Automatisk',
	'toolbarActionFilter': 'Filter',
	'toolbarActionTopBottom': 'Top eller bund',
	'toolbarActionRmvShape': 'Fjern form',
	'toolbarActionToggleShapeDrop': 'Infografisk form',
	'toolbarActionToggleShapeDropTitle': 'Opret infografik',
	'toolbarActionToggleShapeDropText': 'Træk en form til dette felt for at oprette infografik.',
	'toolbarActionAggregationType': 'Opsummér',
	'toolbarDeleteActionText': 'Fjern kolonne',
	'toolbarTextActionText': 'Formatér tekst',
	'toolbarActionFilterLocalKeepSelected': 'Bevar',
	'toolbarActionFilterLocalExcludeSelected': 'Udelad',
	'toolbarActionFilterAllKeepSelected': 'Filter',
	'toolbarActionSimpleCalculation': 'Enkel beregning',
	'toolbarActionDrillBack': 'Tilbage',
	'toolbarActionDrillUp': 'Drill-up',
	'toolbarActionDrillDown': 'Drill-down',
	'toolbarActionNavigate': 'Navigér',
	'toolbarActionCreateFilterGroup': 'Opret ny forbindelse',
	'toolbarActionDisconnectFilterGroup': 'Afbryd alle link',
	'toolbarActionLinkFilterGroup': 'Tilføj en eksisterende forbindelse',
	'toolbarActionLassoSelect': 'Vælg værktøj',
	'toolbarActionRefreshDeveloperWidget': 'Opfrisk',
	'textFontFamilySubClassHairline': 'Fin streg',
	'textFontFamilySubClassThin': 'Tynd',
	'textFontFamilySubClassThinItalic': 'Tynd kursiv',
	'textFontFamilySubClassExtraLight': 'Ekstra lys',
	'textFontFamilySubClassExtraLightItalic': 'Ekstra lys kursiv',
	'textFontFamilySubClassLight': 'Lys',
	'textFontFamilySubClassLightItalic': 'Lys kursiv',
	'textFontFamilySubClassRegular': 'Almindelig',
	'textFontFamilySubClassRegularItalic': 'Almindelig kursiv',
	'textFontFamilySubClassItalic': 'Kursiv',
	'textFontFamilySubClassMedium': 'Medium',
	'textFontFamilySubClassMediumItalic': 'Medium kursiv',
	'textFontFamilySubClassHeavy': 'Fed',
	'textFontFamilySubClassHeavyItalic': 'Fed kursiv',
	'textFontFamilySubClassDemiBold': 'Halvfed',
	'textFontFamilySubClassDemiBoldItalic': 'Halvfed kursiv',
	'textFontFamilySubClassBold': 'Fed',
	'textFontFamilySubClassBoldItalic': 'Fed kursiv',
	'textFontFamilySubClassExtraBold': 'Ekstra fed',
	'textFontFamilySubClassExtraBoldItalic': 'Ekstra fed kursiv',
	'textFontFamilySubClassBlack': 'Sort',
	'textFontFamilySubClassBlackItalic': 'Sort kursiv',
	'textFontFamilySubClassStencil': 'Stencil',
	'dlg_ascending': 'stigende',
	'dlg_descending': 'faldende',
	'dlg_custom': 'tilpasset',
	'dlg_none': 'ingen',
	'dlg_hierarchy': 'hierarki',
	'dlg_namedSet': 'navngivet sæt',
	'dlg_rank': 'rank',
	'remove_slider_handle': 'Fjern håndtag',
	'visualizationLabel': 'Visualisering',
	'chartLabel': '%{chartName} diagram',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Tryk på F12 for at navigere i widgetten.',
	'f10KeyDescription': 'Tryk på F10 for at starte widgetfokus-fremvisningen',
	'playButtonLabel': 'Afspil',
	'dataPlayerValueListLabel': 'Dataafspilningsværdier',
	'localFilterTitle': 'Kun dette objekt',
	'globalFilterTitle': 'Alle objekter',
	'deleteFilter': 'Slet filter',
	'editFilter': 'Redigér filter',
	'ariaEditFilterLabel': 'Tryk på ENTER for at redigere filtret.',
	'ariaDeleteFilterLabel': 'Tryk på DELETE for at slette filtret.',
	'measureFilterBetween': 'Mellem %{lowerBound} og %{upperBound}',
	'measureFilterNotBetween': 'Ikke mellem %{lowerBound} og %{upperBound}',
	'dimFilterIn': 'Medtager: %{in}',
	'dimFilterNotIn': 'Udelader: %{out}',
	'gtFilter': 'Efter %{lowerBound}',
	'ltFilter': 'Før %{upperBound}',
	'ariaEditPrompt': 'Tryk på ENTER for at ændre promptværdien',
	'dataPointFilterTitle': 'Datapunkter',
	'dataPointFilterIncludeSummary': 'Medtaget %{valueCount} datapunkter',
	'dataPointFilterExcludeSummary': 'Udeladt %{valueCount} datapunkter',
	'widgetFiltersLabel': 'Widget-filtre',
	'coachMarkTitleSpiralTarget': 'Redigér omfang',
	'coachMarkContentSpiralTarget': 'Her kan du få adgang til og ændre styreprogramvalget for dit mål.',
	'srILVTreeLabel': 'Liste',
	'geomapUnrecognizedLocations': 'Ukendte placeringer:',
	'geomapAmbiguousLocations': 'Uklare områder:',
	'visualizationNotifications': 'Visualiseringsadviseringer:',
	'dataNotifications': 'Dataadviseringer:',
	'autobinSuggestion': 'Aktivér auto-gruppering',
	'LIVE_empty_visualization_hint_title': 'Byg din visualisering',
	'LIVE_empty_visualization_hint_description': 'Træk data her eller til felterne.',
	'LIVE_slots_required_field_description': '%{asterisk} Angiver et påkrævet felt',
	'LIVE_slots_drag_and_drop_description': 'Træk og placér data til felterne ovenfor for at bygge og filtrere visualiseringen.',
	'dwErrorLoadingAvailableVisualizations': 'De tilgængelige visualiseringsdefinitioner kan ikke indlæses',
	'moreDataIndicator': 'Data blev afkortet ved %{threshold} elementer. Anvend et filter for at få vist færre.',
	'nonCtxTopBottomInvalid': 'Definition af en top- og bundregel uden en kontekst understøttes ikke for krydstabeller. Den blev fjernet fra denne krydstabeloversigt.  Omdefinér reglen på en eller flere kategorier i konteksten til %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'Objektet kan ikke indlæses, fordi det mangler en visualiseringsdefinition.',
	'dwErrorLoadingVisualizationListNotFound': 'Visualiseringen kan ikke indlæses.',
	'dwErrorRunningQuery': 'Det er ikke muligt at hente data fra datasættet %{datasetName}.',
	'dwErrorGeoData': 'Det er ikke muligt at vise de geografiske data på et kort. Vælg en anden visualiseringstype.',
	'dwPromptSignonCancelWarning': 'Dataene til denne visualisering er ikke tilgængelige. Brug de rigtige legitimationsoplysninger.',
	'dwErrorMissingDataset': 'Visualiseringen kan ikke indlæses, fordi det tilknyttede datasæt \'%{datasetName}\' ikke er tilgængeligt.',
	'dwErrorRenderingVisualization': 'Denne visualisering kan ikke indlæses.',
	'dwErrorVisualizationTooSmall': 'Visualiseringen er for lille til, at dens data kan vises. Gør visualiseringen større, eller begræns de indeholdte data.',
	'errorSourceNotFound': 'Visualiseringen kan ikke indlæses, fordi den tilknyttede kilde \'%{sourceName}\' ikke er tilgængelig.',
	'errorActionNotSupported': 'Denne handling understøttes ikke for datakilde \'%{sourceName}\'.',
	'errorMeasureNotSupportedOnMultiEdges': 'Visualiseringen har målinger på flere kanter. Dette understøttes ikke længere. Placér kun målinger på én kant.',
	'errorExceedAllowableValue': 'De anslåede antal celler overstiger den tilladte værdi på 100000. Angiv filtrering til de projekterede sæt for at reducere antallet af celler.',
	'propScaleLabel': 'Antal ikoner',
	'propScaleDescription': 'Vælg antal ikoner',
	'propScaleFew': 'Lav',
	'propScaleDefault': 'Standard',
	'propScaleMany': 'Høj',
	'lastRefresh': 'Sidst opfrisket: for %{timeInterval} siden',
	'widgetTimer': 'Timer til widget',
	'datasetItemsUnavailable': 'Nogle af de datasætelementer, der bruges i denne visualisering, er ikke tilgængelige.',
	'datasetItemUnavailable': 'Datasætelementet er ikke tilgængeligt',
	'retry': 'Prøv igen',
	'widgetConditionalFormatLabel': 'Aktivér/deaktivér kontrolelementer i betinget format',
	'widgetConditionalFormatTitle': 'Redigér betinget formateringsfarve',
	'conditionalPalettePickerLabel': 'Distribution af %{title} værdier',
	'HistogramYAxisTitle': 'Antal',
	'crosstabName': 'Krydstabel',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'Ikke tilgængelig',
	'summaryLabel': '%{label} med værdien %{value}',
	'infographicLabel': '%{label} med værdien %{value}',
	'warning': 'Advarsel',
	'swapRowsAndColumns': 'Byt om på rækker og kolonner',
	'hideSummariesLabel': 'Skjul resuméer',
	'showSummariesLabel': 'Vis opsummeringer',
	'hideRowColumn': 'Skjul',
	'showAllRowColumn': 'Vis alle',
	'dataAssetPropertiesLabel': 'Egenskaber for visualisering',
	'evAdd': 'Tilføj en kolonne',
	'evCollapse': 'Skjul',
	'evColumns': 'Kolonner',
	'evLocalFilters': 'Lokale filtre',
	'evExpand': 'Udvid',
	'evFilterTooltip': 'Filter',
	'missingColumn': 'Mangler: %{columnLabel}',
	'missingFiltering': 'Manglende filtre på kolonner:',
	'missingDataItem': 'Det dataelement, der refereres til, \'%{dataItemId}\', findes ikke i widgetten.',
	'heatByLabel': 'Varme efter',
	'toolbarChangeVisualization': 'Skift visualisering',
	'modellingRelatedTablesNoneFound': 'Ingen relaterede tabeller fundet',
	'processing': 'Behandler...',
	'errorCellWarning': 'Nogle opsummeringsværdier kan ikke beregnes.',
	'aggregateTypeToggler': 'Vis aggregeringstype',
	'maxColumnsExceeded': 'Det maksimale antal kolonner er overskredet. %{columns} er slettet.',
	'unboundColumns': 'Kan ikke bruge følgende kolonner: %{columns}.',
	'unboundColumn': 'Kan ikke bruge følgende kolonne: %{columns}.',
	'recommendRequestFailed': 'Anbefalingsanmodning ikke udført. Kontakt administratoren.',
	'visualizationDoesNotSupportOLAP': 'Denne visualisering kan ikke oprettes. Den er baseret på en OLAP-datakilde. Brug en anden understøttet datakilde.',
	'showDataBehindVizLabel': 'Vis data',
	'showDataBehindVizNotSupportedLabel': 'Vis data understøttes ikke for denne visualiseringstype',
	'exploreData': 'Udforsk...',
	'newExplore': 'Ny udforskning',
	'thumbnails_error_fetching': 'Fejl under hentning af miniaturer',
	'loadedThumbnailImage': 'Indlæst %{visType}-visualiseringsminiaturebillede',
	'autobinAxisLabel': 'grupper',
	'recommended_visualizations': 'Anbefalede visualiseringer',
	'all_visualizations': 'Alle visualiseringer',
	'edit': 'Redigér',
	'selectTargetDialogTitle': 'Vælg et drill-through-mål',
	'noTargetInCM': 'Kan ikke finde målet til drill-through',
	'errorDrillDefinition': 'Der er sket en fejl under tilføjelse eller redigering af drill-through-definitionen.',
	'errorDrillToTarget': 'Der er opstået en fejl under drill-funktionen til \'%{targetName}\'',
	'drillThroughMappingViewLabel': 'Tilføj kolonner fra dashboardet til prompterne på målrapporten',
	'drillthroughScopeRadioLabel': 'Anvend denne definition til:',
	'drillthroughScopeRadioOptionVisualization': 'Kun denne visualisering',
	'drillthroughScopeRadioOptionConnection': 'Visualiseringer i den samme forbindelse, der anvender den samme datakilde',
	'drillthroughScopeRadioOptionDashboard': 'Alle visualiseringer til %{perspective}, der anvender den samme datakilde',
	'drillThroughParametersColumnTitle': '\'%{targetName}\'-prompter:',
	'drillThroughMetadataColumnTitle': '\'%{boardName}\'-datakolonner:',
	'drillThroughDefinitionNoParameter': 'Drill-through-målet indeholder ingen prompter.',
	'drillThroughDefinitionErrorQueryingReport': 'Ret problemet med målrapporten, og prøv derefter at oprette drill-through-definitionen.',
	'drillThroughDefinitionErrorDlgTitle': 'Der er sket en fejl',
	'dlg_back': 'Gå tilbage',
	'dlg_close': 'Luk',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Annullér',
	'dlg_apply': 'Anvend',
	'drillthrough_unsaveMsg': 'Fortsæt uden at gemme \'%{name}\'?',
	'drillthrough_jumpTo': 'Drill-through-definition: %{name}',
	'drillthrough_jumpToLabel': 'Drill through',
	'drillthrough_manage': 'Administrér...',
	'drillthrough_addNewTarget': 'Tilføj en ny drill-through-definition',
	'drillthrough_manageJumpPaths': 'Administrér drill-through-definitioner',
	'drillthrough_manageJumpPaths_edit': 'Redigér \'%{name}\'',
	'drillthrough_manageJumpPaths_delete': 'Slet \'%{name}\'',
	'drillthrough_manageAddAnotherTarget': 'Tilføj en anden drill-through-definition',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Bekræft sletning',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Er du sikker på, at du vil slette drill-through \'%{name}\'?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Sammenfaldende drill-through-navn',
	'drillthrough_definitionMessage': 'Drill-through \'%{name}\' findes allerede. Angiv et andet navn',
	'drillthrough_jumpToTarget_notFound': 'Må ikke fundet for drill-through \'%{name}\'',
	'drillThroughDefinitionNoParameterSubTitle': 'Ingen kontekst bliver overført til målrapporten.',
	'drillthrough_titleLabel': 'Titel',
	'drillthrough_subTitle': 'Konteksten for visualiseringen i din kilde bruges til at filtrere målet %{perspective}.',
	'noPrompt': 'Ingen prompter',
	'formatAutoDescription': 'Angiver automatisk det format, der er overtaget fra din datakilde eller visualisering.',
	'formatDefaultDescription': 'Standard angiver det format, der er overtaget fra systemet',
	'createCustomGroupAction': 'Opret datagruppe',
	'removeCustomGroupAction': 'Fjern datagruppe',
	'editCustomGroupAction': 'Redigér datagruppe',
	'renameCustomGroupAction': 'Omdøb datagruppe',
	'createCustomGroupErrorToast': 'Datagruppen kan ikke oprettes.',
	'removeCustomGroupErrorToast': 'Datagruppen kan ikke fjernes.',
	'editCustomGroupErrorToast': 'Datagruppen kan ikke redigeres.',
	'renameCustomGroupErrorToast': 'Datagruppen kan ikke omdøbes.',
	'customGroupLabel': 'Datagruppe',
	'ungroupCustomGroupLabel': 'Ophæv gruppe',
	'renameCustomGroupLabel': 'Omdøb',
	'createCustomGroupLabel': 'Opret',
	'customGroupingLabel': '%{columnLabel} (Gruppe)',
	'createCustomSort': 'Opret tilpasset sortering',
	'createCustomSortTitle': '%{createCustomSort}: %{name}',
	'createCustomSortDesc': 'Vælg tilgængelige elementer. Omarrangér dem derefter for at oprette en tilpasset sortering.',
	'availableItems': 'Tilgængelige elementer',
	'selectAll': '(Vælg alle)',
	'customSortOrder': 'Tilpas sorteringsrækkefølge',
	'selectAvailableItemsDesc': 'Vælg tilgængelige elementer. Omarrangér dem derefter.',
	'moveToTop': 'Flyt til toppen',
	'clear': 'Ryd',
	'sortRemainingItemsBy': 'Sortér resterende elementer efter',
	'clearAll': 'Ryd alle',
	'resetTooltip': 'Alle elementer bliver fjernet fra listen %{customSortOrder}. Og rullelisten %{sortRemainingItemsBy} vender tilbage til standardværdien.',
	'manyItemsWarning': 'Hvis du vælger mange elementer, kan det påvirke ydeevnen for dit dashboard.',
	'manyItemsSelected': 'Der er valgt mere end %{maxItems} elementer, hvilket kan påvirke ydeevnen af dit dashboard.',
	'somethingWentWrong': 'Der er sket en fejl',
	'unableToLoadItems': 'Kan ikke indlæse tilgængelige elementer.',
	'tryAgain': 'Forsøg igen',
	'customSortLabel': 'Tilpasset sortering',
	'applyError': 'Kan ikke anvende %{action}.',
	'searchReturnedNoResults': 'Søgningen gav ingen resultater',
	'tryDifferentSearchTerm': 'Prøv et andet søgeudtryk',
	'extVisSystem': 'System',
	'extVisCustom': 'Tilpasset',
	'customVisTestVisualization': 'Testvisualisering',
	'extVisCustomVisPreview': 'eksempel',
	'extVisCustomPreviewWidgets': 'Udviklerwidgetter',
	'extVisCustomVVisualization': 'Visualisering',
	'extVisCustomVisuals': 'Tilpassede visualiseringer',
	'noPermissionToManage': 'Du har ikke tilladelse til at administrere tilpassede visualiseringer.',
	'extVisCustomUpdate': 'Opdatér',
	'extVisCustomDelete': 'Slet',
	'extVisNoCustomVisuals': 'Ingen tilpassede visualiseringer',
	'extVisNoCustomVisualsMsg': 'Der er i øjeblikket ingen tilpassede visualiseringer i din organisation',
	'extVisAddCustomVisual': 'Tilføj en tilpasset visualisering',
	'extVisNoCustomVisualsAdminMsg': 'Der er i øjeblikket ingen tilpassede visualiseringer. Tilføj en for at komme i gang',
	'extVisNoSDKConnection': 'Der er ikke oprettet nogen forbindelse til den lokale fil',
	'extVisNoSDKPreviewMsg': 'Hvis du vil have vist et eksempel på dine visualiseringer, skal du oprette en forbindelse.',
	'extVisMore': 'Mere',
	'extVisDeleteDialogTitle': 'Slet tilpasset visualisering',
	'extVisDeleteDialogBody': 'Er du sikker på, at du vil slette denne tilpassede visualisering? Det kan være i brug af andre dashboards og rapporter.',
	'extVisDeleteConfirmation': 'Din tilpassede visualisering er slettet.',
	'extVisDeleteError': 'Dine tilpassede visualisering kan ikke slettes. %{msg}',
	'extVisCloseToast': 'Luk nu',
	'extVisAdd': 'Din tilpassede visualisering er tilføjet.',
	'extVisAddError': 'Din tilpassede visualisering kan ikke tilføjes. %{msg}',
	'extVisUpdate': 'Din tilpassede visualisering er opdateret.',
	'extVisUpdateError': 'Din tilpassede visualisering kan ikke opdateres. %{msg}',
	'extVisAddProgress': 'Importerer %{name}',
	'extVisUpdateProgress': 'Opdaterer %{name}',
	'extPermissionTitle': 'Begrænset adgang eller slettet tilpasset visualisering',
	'extPermissionBody': 'Denne tilpassede visualisering kan ikke fremvises, fordi den er slettet, eller fordi adgangen er begrænset.',
	'customVizSaveWarning': 'Dine tilpassede visualiseringer kan ikke gemmes. De er ikke importeret.',
	'schematicTestCaption': 'Test skematik',
	'schematicServiceRequestError': 'Skematikservicefejl',
	'extVisPreviewMessage': 'Dette er en prøve. Visualiseringen er ikke tilføjet til produktet endnu.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Ikke defineret',
	'kpiDefaultTargetLabel': 'Mål',
	'kpiNonNumericTarget': 'Målværdien skal være et tal.',
	'kpiManualTargetSlotFilled': 'Værdi anvendt i felt',
	'kpiAutoValueSize': 'Automatisk',
	'kpiUnableDrawSparklineLabel': 'Kan ikke tegne minidiagram',
	'kpiUnableDrawSparklineInfo': 'Et minidiagram kræver mindst to tidspunkter. Revidér data, eller tilpas filtrene for at få vist minidiagrammet.',
	'conditionalFormattingEnabled': 'Betinget farve',
	'currentConditionalPalette': 'Aktuel betinget palet',
	'sectionName_range': 'Angiv interval',
	'rangeScaleLabel': 'Skala',
	'rangeScalePercentage': 'Procent',
	'rangeScaleNumeric': 'Numerisk',
	'numberOfSteps': 'Antal intervaller',
	'conditionalFormattingSelectedStep': 'Valgt interval',
	'conditionalFormattingStartValue': 'Startværdi',
	'conditionalFormattingEndValue': 'Slutværdi',
	'conditionalFormattingTextColor': 'Tekstfarve',
	'conditionalFormattingMin': 'Min.',
	'conditionalFormattingMax': 'Maks.',
	'conditionalFormattingNonNumericValue': 'Værdien skal være et tal.',
	'conditionalFormattingStepIndexInvalid': 'Intervalindekset er ugyldigt.',
	'conditionalFormattingValueOutOfBoundsInvalid': 'Værdien skal være i intervallet %{start} - %{end}.',
	'conditionalFormattingValueShouldBeLower': 'Værdien skal være mindre end eller lig med %{value}.',
	'conditionalFormattingValueSouldBeHigher': 'Værdien skal være større end eller lig med %{value}.',
	'conditionalFormattingDeleteStep': 'Fjern valgt interval',
	'conditionalFormattingRestoreSteps': 'Gendan intervaller',
	'conditionalFormattingReversePalette': 'Omvend farver',
	'conditionalFormattingShapeIndicator': 'Indikatorfigur',
	'conditionalFormattingIconNone': 'Ingen figur',
	'conditionalFormattingIconArrowUp': 'Pil op',
	'conditionalFormattingIconArrowRight': 'Pil mod højre',
	'conditionalFormattingIconArrowDown': 'Pil ned',
	'conditionalFormattingIconCaretUp': 'Cirkumfleks op',
	'conditionalFormattingIconDash': 'Stiplet',
	'conditionalFormattingIconCaretDown': 'Cirkumfleks ned',
	'conditionalFormattingIconCheckmark': 'Hak',
	'conditionalFormattingIconWarning': 'Advarsel',
	'conditionalFormattingIconXSymbol': 'X-symbol',
	'conditionalFormattingIconCircle': 'Cirkel',
	'conditionalFormattingIconTriangle': 'Trekant',
	'conditionalFormattingIconDiamond': 'Rombe',
	'conditionalFormattingIconFaceSatisfied': 'Ansigt, tilfreds',
	'conditionalFormattingIconFaceNeutral': 'Ansigt, neutral',
	'conditionalFormattingIconFaceDissatisfied': 'Ansigt, utilfreds',
	'suppression': 'Undertrykkelse',
	'suppressNone': 'Ingen',
	'suppressRowsAndColumns': 'Rækker og kolonner',
	'suppressRows': 'Rækker',
	'suppressColumns': 'Kolonner',
	'enableSuppression': 'Aktivér undertrykkelse',
	'disableSuppression': 'Deaktivér undertrykkelse',
	'loadVisDefinitionError': 'Kan ikke indlæse definition for visualisering %{id}',
	'emptyVisualization': 'Tom visualisering',
	'expandCollapse': 'Udvid og skjul',
	'expandBtnLabel': 'Udvid',
	'collapseBtnLabel': 'Skjul',
	'prop_sizeInputNonNumericValue': 'Værdien skal være et tal.',
	'prop_sizeValueShouldBeHigher': 'Værdien skal være større end %{value}.',
	'fontPropLabel': 'Fontserie',
	'fontSizePropLabel': 'Fontstørrelse',
	'sectionItemAxisTitle': 'Titel på elementakse',
	'sectionItemAxisLabel': 'Etiket på elementakse',
	'sectionValueAxisTitle': 'Titel på værdiakse',
	'sectionValueAxisLabel': 'Etiket på værdiakse',
	'fontFamily': 'family',
	'fontSize': 'size',
	'visExportFileName': 'Visualisering',
	'ds-missingDataSet': 'Kan ikke finde datasættet. Kontrollér, at datasættet er oprettet.',
	'ds-missingDashboardId': 'Gem dashboardet, før du opretter datasættet.',
	'ds-unsupportedDataSourceType': 'Datakildetypen %{type} understøttes ikke.'
});
